import { render } from "./MessageInputHandler.vue?vue&type=template&id=0be6a240&ts=true"
import script from "./MessageInputHandler.ts?vue&type=script&lang=ts&external"
export * from "./MessageInputHandler.ts?vue&type=script&lang=ts&external"

import "./MessageInputHandler.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__